<template>
  <div class="jinmai-layout">
    <!-- 顶部栏：电话、邮箱、搜索 -->
    <div class="top_bar">
      <el-row type="flex" align="middle" class="container top_menu">
        <el-col :xs="24" :sm="18" :md="18" class="top_name">
          <p><span class="glyphicon glyphicon-phone-alt" aria-hidden="true"></span>&nbsp; 13606083580&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
          <p><span class="glyphicon glyphicon-envelope" aria-hidden="true"></span>&nbsp; <a href="mailto:370069545@qq.com">370069545@qq.com</a></p>
        </el-col>
        <el-col :xs="24" :sm="6" :md="6" id="topsearch">
          <form id="searchform" @submit.prevent="onSearch" class="search_group">
            <div class="input-group">
              <input 
                type="text" 
                v-model="searchKey" 
                class="form-control input-sm" 
                placeholder="Product search"
              />
              <span class="input-group-btn">
                <span id="submit_search" @click="onSearch" title="Product search" class="glyphicon glyphicon-search btn-lg" aria-hidden="true"></span>
              </span>
            </div>
          </form>
        </el-col>
      </el-row>
    </div>

    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container nav-inner">
        <router-link to="/" class="logo-wrap">
          <img src="/advance/pics/20211115/1636955381.jpg" class="logo" alt="竞迈广告设计制作" onerror="this.src='https://via.placeholder.com/330x70/0AB4A4/fff?text=竞迈广告'" />
        </router-link>
        <div class="nav-menu">
          <el-menu
            mode="horizontal"
            :default-active="activeMenu"
            :router="true"
            background-color="#fff"
            text-color="#888"
            active-text-color="#0AB4A4"
            class="main-menu"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/about">关于竞迈</el-menu-item>
            <el-menu-item index="/news">竞迈资讯</el-menu-item>

            <!-- 动态生成产品分类菜单（一级分类，鼠标悬停展开二级分类） -->
            <el-submenu 
              v-for="category in productCategories" 
              :key="category.id" 
              :index="'category-' + category.id"
            >
              <template slot="title">{{ category.name }}</template>
              <el-menu-item 
                v-for="subCategory in category.subCategories" 
                :key="subCategory.id"
                :index="'/product?categoryId=' + subCategory.id"
              >
                {{ subCategory.name }}
              </el-menu-item>
            </el-submenu>

            <el-menu-item index="/feedback">留言反馈</el-menu-item>
            <el-menu-item index="/contact">联系我们</el-menu-item>
          </el-menu>
        </div>
      </div>
    </nav>

    <!-- 主内容 -->
    <main class="main container">
      <router-view />
    </main>

    <!-- 底部固定栏（移动端） -->
    <nav class="footer_nav">
      <div class="foot_nav btn-group dropup" :class="{ open: showShareMenu }" @click="showShareMenu = !showShareMenu">
        <a class="dropdown-toggle" href="#" @click.prevent><span class="glyphicon glyphicon-share btn-lg" aria-hidden="true"></span> Share</a>
        <div class="dropdown-menu webshare">
          <!-- Share options can be added here -->
        </div>
      </div>
      <div class="foot_nav">
        <a href="tel:13606083580"><span class="glyphicon glyphicon-phone btn-lg" aria-hidden="true"></span>Call</a>
      </div>
      <div class="foot_nav" @click="toggleMobileMenu">
        <span class="glyphicon glyphicon-th-list btn-lg" aria-hidden="true"></span>Menu
      </div>
      <div class="foot_nav">
        <a id="gototop" href="#" @click.prevent="goTop"><span class="glyphicon glyphicon-circle-arrow-up btn-lg" aria-hidden="true"></span>Top</a>
      </div>
    </nav>

    <!-- 页脚 -->
    <footer class="container">
      <div class="copyright">
        <p>CopyRight 2021 All Right Reserved&nbsp;厦门竞迈文化传媒有限公司 版权所有</p>
        <p class="copyright_p">电话：13606083580 地址：厦门火炬高新区（翔安）产业区翔星路98号强业楼4层</p>
        <p class="copyright_p icp-beian">
          <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">闽ICP备20005836号</a>
        </p>
        <p class="copyright_p">竞迈.厦门广告制作公司&nbsp;专业广告设计、广告制作及安装为一体的广告牌制作公司，20年经验，超过2000多位客户的选择!</p>
        <p class="copyright_p">关键词：品牌设计、VI设计、LOGO设计、产品包装设计、标识标牌、led发光字制作、亚克力字制作、不锈钢字制作、户外广告牌、灯箱制作</p>
        <p class="copyright_p">门头制作、门店招牌、形象墙、文化墙、导视系统、亮化工程、楼体大字、围档广告、包装印刷等广告制作服务</p>
        <p class="copyright_p">厦门广告公司,厦门广告设计公司,厦门广告制作公司,厦门广告安装公司,厦门平面设计公司、翔安广告公司、同安广告公司</p>
        <p class="copyright_p">翔安广告制作、同安广告制作、海沧广告制作、集美广告制作、思明广告制作、湖里广告制作、</p>
      </div>
    </footer>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'Layout',
  data() {
    return {
      searchKey: '',
      showShareMenu: false,
      productCategories: []
    }
  },
  computed: {
    activeMenu() {
      const path = this.$route.path
      if (path === '/') return '/'
      if (path.startsWith('/about')) return '/about'
      if (path.startsWith('/news')) return '/news'
      if (path.startsWith('/contact')) return '/contact'
      if (path.startsWith('/feedback')) return '/feedback'
      if (path.startsWith('/product')) return 'product'
      return path
    }
  },
  mounted() {
    this.loadProductCategories()
  },
  methods: {
    // 加载产品分类（一级分类及其二级分类用于菜单显示）
    async loadProductCategories() {
      try {
        // 获取产品分类列表（只获取启用的顶级分类）
        const categoryRes = await request({
          url: '/bidding/productCategory/list',
          method: 'get',
          params: {
            status: '1',
            parentId: 0
          }
        })

        if (categoryRes.code === 200 && categoryRes.data && categoryRes.data.length > 0) {
          // 按 sort 字段排序
          const categories = categoryRes.data.sort((a, b) => (a.sort || 0) - (b.sort || 0))
          
          // 为每个一级分类加载二级分类
          const categoryPromises = categories.map(category => this.loadSubCategories(category))
          this.productCategories = await Promise.all(categoryPromises)
        }
      } catch (error) {
        console.error('加载产品分类失败:', error)
        // 不显示错误提示，避免影响用户体验
      }
    },

    // 加载一级分类下的二级分类
    async loadSubCategories(category) {
      try {
        const subCategoryRes = await request({
          url: '/bidding/productCategory/list',
          method: 'get',
          params: {
            status: '1',
            parentId: category.id
          }
        })

        let subCategories = []
        if (subCategoryRes.code === 200 && subCategoryRes.data) {
          // 过滤并按 sort 字段排序
          subCategories = subCategoryRes.data
            .filter(subCategory => subCategory.status === '1')
            .sort((a, b) => (a.sort || 0) - (b.sort || 0))
            .map(subCategory => ({
              id: subCategory.id,
              name: subCategory.name
            }))
        }

        return {
          ...category,
          subCategories: subCategories
        }
      } catch (error) {
        console.error(`加载分类 ${category.name} 的二级分类失败:`, error)
        return {
          ...category,
          subCategories: []
        }
      }
    },

    onSearch() {
      if (this.searchKey.trim()) {
        this.$router.push({ path: '/product', query: { key: this.searchKey } })
      }
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    toggleMobileMenu() {
      // Toggle mobile menu if needed
      const navbar = document.getElementById('navbar')
      if (navbar) {
        navbar.classList.toggle('collapse')
      }
    }
  }
}
</script>

<style scoped>
.jinmai-layout { padding-bottom: 60px; }

/* 顶部栏样式 */
.top_bar { background-color: #ededed; }
.top_menu { height: 95px; }
.top_name { padding-top: 65px; color: #888; }
.top_name p { display: inline; margin: 0; }
.top_name a { color: #888; text-decoration: none; }
.top_name a:hover { color: #333; }
.glyphicon { font-family: 'Glyphicons Halflings'; display: inline-block; }
.glyphicon-phone-alt:before { content: "\e145"; }
.glyphicon-envelope:before { content: "\2709"; }
.glyphicon-search:before { content: "\e003"; }
.glyphicon-share:before { content: "\e095"; }
.glyphicon-phone:before { content: "\e145"; }
.glyphicon-th-list:before { content: "\e012"; }
.glyphicon-circle-arrow-up:before { content: "\e133"; }

/* 搜索框样式 */
#topsearch { padding-top: 55px; }
.search_group { float: right; margin: 28px 0 0 0; background-color: #f5f5f5; border: 1px solid #f5f5f5; border-radius: 25px; height: 35px; }
.search_group .input-group { display: flex; width: 100%; align-items: center; height: 100%; }
.search_group .form-control { border-radius: 0; box-shadow: none; color: #858585; padding: 6px 14px 0 14px; background: transparent; border: none; flex: 1; height: 100%; font-size: 13px; }
.search_group .form-control:focus { box-shadow: none; border-color: #b2e0fb; outline: none; }
.search_group .input-group-btn { display: flex; align-items: center; height: 100%; }
#submit_search { color: #31363c; font-size: 13px; cursor: pointer; padding: 0 12px; display: flex; align-items: center; height: 100%; }
#submit_search:hover { color: #97D5CF; }

/* 导航栏样式 */
.navbar { background: #fff; box-shadow: 0 10px 16px -7px rgba(0,0,0,0.09); margin: 0; border: none; }
.nav-inner { display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; min-height: 90px; }
.logo-wrap { display: block; }
.logo { margin: 15px 0 10px 0; max-width: 330px; max-height: 70px; display: block; }
.main-menu { border: none !important; }
.main-menu .el-menu-item a { color: inherit; }
.main-menu .el-submenu__title { color: #888; }

/* 主内容区 */
.main { background: #fff; min-height: 400px; padding-top: 0; }

/* 底部固定导航栏 */
.footer_nav { display: none; position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000; background: #fafafa; border-top: 1px solid #e4e4e4; }
.footer_nav .foot_nav { width: 25%; float: left; text-align: center; color: #898989; cursor: pointer; padding: 10px 0; position: relative; }
.footer_nav .foot_nav a { color: #898989; display: block; text-decoration: none; }
.footer_nav .foot_nav:hover, .footer_nav .foot_nav:focus { background-color: #e4e4e4; }
.footer_nav .foot_nav a:hover, .footer_nav .foot_nav a:focus { color: #333; }
.btn-lg { font-size: 18px; }
.btn-group { position: relative; }
.dropdown-menu { display: none; position: absolute; bottom: 100%; left: 0; background: #fff; border: 1px solid #ddd; border-radius: 4px; padding: 10px; min-width: 150px; z-index: 1001; }
.btn-group.open .dropdown-menu { display: block; }

/* 页脚样式 */
footer { text-align: center; background-color: #f6f6f6; color: #888; padding: 40px 0 25px 0; font-size: 13px; margin-top: 0; }
.copyright { line-height: 20px; }
.copyright a { color: #888; text-decoration: none; }
.copyright a:hover { color: #333; }

/* 响应式 */
@media (max-width: 768px) {
  .top_name { display: none; }
  .top_menu { height: 70px; }
  #topsearch { padding-top: 18px; }
  .search_group { margin: 18px 0 10px 0; }
  .logo { max-width: 180px; max-height: 40px; margin: 5px 0 5px 10px; }
  .footer_nav { display: flex; }
  .main { padding-bottom: 20px; }
  footer { margin-bottom: 50px; }
}

@media (max-width: 767px) {
  .copyright_p { display: none; }
  .copyright_p.icp-beian { display: block; margin-top: 8px; }
}
</style>
